<template>
  <div>
      <ParentDetails :personNumber="number" :parentNumber="1" @parentDetailsChanged="onInputChange(1)" v-model="personDetails.parentDetails[0]"/>
      <hr>
      <ParentDetails :personNumber="number" :parentNumber="2" @parentDetailsChanged="onInputChange(2)" v-model="personDetails.parentDetails[1]"/>
  </div>
</template>

<script>
import ParentDetails from './ParentDetails.vue';

export default {
  methods: {
    parentDetailsChanged(childParentDetails, number) {
      this.personDetails.parentDetails[number] = {...this.personDetails.parentDetails[number], ...childParentDetails}
    }
  },
  props: {
    number: String,
    value: Object,
  },
  computed: {
    personDetails: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  components: {
    ParentDetails,
  }
}

</script>